import React from 'react'

import PropTypes from 'prop-types'

import * as S from './styled'

const BrandPartner = ({ partner }) => (
  <S.BrandPartnerWrapper>
    <S.BrandPartnerLink
      href={partner.url}
      target="_blank"
      rel="noopener noreferrer"
      title={partner.title}
    >
      <S.BrandPartnerLogo className="bg-contain" image={partner.image} />
    </S.BrandPartnerLink>
  </S.BrandPartnerWrapper>
)

BrandPartner.propTypes = {
  partner: PropTypes.object.isRequired
}

export default BrandPartner
